<template>
    <div class="modal" :class="{ 'is-active': show }">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Edición de Operador</p>
            </header>
            <section v-if="operator" class="modal-card-body">
                <div class="field">
                    <label class="label">Nombre</label>
                    <div class="control">
                        <input
                            v-model="operator.name"
                            class="input"
                            type="text"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label">Email</label>
                    <div class="control">
                        <input
                            v-model="operator.email"
                            class="input"
                            type="text"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label">Trámites</label>
                    <div class="control has-text-centered">
                        <button
                            v-for="skill in skills"
                            :key="skill.id"
                            class="button m-1"
                            :class="{ 'is-primary': haveSkill(skill) }"
                            @click="toggleSkill(skill)"
                        >
                            {{ skill.id }}
                        </button>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button
                    class="button is-primary"
                    :class="{ 'is-loading': saving }"
                    @click="updateOperator"
                >
                    {{ $t("general.save") }}
                </button>
                <button
                    class="button is-danger"
                    @click="close"
                    :class="{ 'is-loading': saving }"
                >
                    {{ $t("browser-compatibility.close") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";

export default {
    name: "edit-operator",
    props: {
        display: {
            type: Boolean,
            default: false,
        },
        operator: {
            type: Object,
            default: null,
        },
        skills: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            show: false,
            saving: false,
            operatorSkills: [],
        };
    },
    watch: {
        display(display) {
            this.show = display;
            if (this.show) {
                this.loadSkills();
            } else {
                this.operatorSkills = [];
            }
        },
    },
    methods: {
        close(refresh) {
            this.$emit("close", refresh);
        },
        async updateOperator() {
            this.saving = true;
            try {
                let payload = {
                    id: this.operator.userId,
                    name: this.operator.name,
                    email: this.operator.email,
                    skills: this.operatorSkills,
                };
                await RepositoryFactory.operators.update(payload);
                this.close(true);
            } catch (error) {
                window.console.log(error);
            }
            this.saving = false;
        },
        toggleSkill(skill) {
            if (this.haveSkill(skill)) {
                let index = this.operatorSkills.indexOf(skill);
                this.operatorSkills.splice(index, 1);
            } else {
                this.operatorSkills.push(skill);
            }
        },
        haveSkill(skill) {
            return (
                this.operatorSkills.find((s) => s.id === skill.id) !== undefined
            );
        },
        loadSkills() {
            for (const skill of this.skills) {
                if (this.operator.skills.find((s) => s.id === skill.id)) {
                    this.operatorSkills.push(skill);
                }
            }
        },
    },
};
</script>